import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Card, CardContent, Typography, LinearProgress, Box } from '@mui/material';
import { formatRelativeDate } from '../../utils/date';
function getLevelColor(pct) {
    if (pct > 50)
        return 'success';
    if (pct >= 25)
        return 'warning';
    return 'error';
}
export default function SaltLevelTile({ estimatedLevelPct, insufficientData, latestReading }) {
    const hasData = !insufficientData && estimatedLevelPct !== undefined;
    const roundedPct = hasData ? Math.round(estimatedLevelPct) : 0;
    const color = hasData ? getLevelColor(roundedPct) : 'inherit';
    const caption = hasData
        ? (latestReading ? `Adjusted for reading ${formatRelativeDate(latestReading.date)}` : 'Estimated from usage history')
        : undefined;
    return (_jsx(Card, { elevation: 2, children: _jsxs(CardContent, { children: [_jsx(Typography, { variant: "subtitle2", color: "text.secondary", children: "Salt Level" }), hasData ? (_jsxs(_Fragment, { children: [_jsx(Box, { sx: { display: 'flex', alignItems: 'baseline', gap: 0.5, mb: 1 }, children: _jsxs(Typography, { variant: "h5", sx: { color: `${color}.main` }, children: [roundedPct, "%"] }) }), _jsx(LinearProgress, { variant: "determinate", value: roundedPct, color: color, sx: { height: 8, borderRadius: 1 } }), _jsx(Typography, { variant: "caption", color: "text.secondary", sx: { mt: 0.5, display: 'block' }, children: caption })] })) : (_jsx(Typography, { variant: "h5", children: "Needs more history" }))] }) }));
}
